module.exports = __webpack_public_path__ + "static/media/instructivoac6.780ed7af.png";